import React, { useMemo } from 'react'
import classNames from 'classnames'
import { TAB } from '../../inspiration/enum'
import { SwitchPageTabContent } from '../../../components/switchTab'
import OfficialPastDrawerBtn from '../pastDrawer'
import styles from './index.module.less'

export default ({
  info,
  total,
}) => {
  const tabValue = TAB.ALL

  const _tabOption = useMemo(() => {
    const TAB_OPTION = [
      { label: '款式', value: TAB.ALL, auth: true, num: total, },
    ]
    return TAB_OPTION
  }, [total])

  return <div className={styles['coll-info-wrap']}>
    <div style={{ padding: '20px 24px 16px 24px' }}>
      <div className="coll-info-wrap-header">
        <div className="coll-info-wrap-header-title">
          <div className={classNames('info-title')}>
            {info.name}
          </div>
          <OfficialPastDrawerBtn />
        </div>
      </div>
    </div>
    <div className="coll-info-wrap-tab-content">
      <SwitchPageTabContent
        className="coll-info-wrap-tab"
        value={tabValue}
        options={_tabOption.filter(i => i.auth)}
      />
    </div>
  </div>
}
